module.exports = __webpack_public_path__ + "assets/img/Structure_img_mask2.5e76032c.png";